import { useState } from 'react';

import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';
import { ICreditCondition } from '@r1-frontend/api-domru/payments/v1/credits/condition';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import OptionList, { IProps as IOptionListProps } from '@r1-frontend/ui-react/components/OptionList';
import TestDriveOptions from '@r1-frontend/ui-react/components/OptionList/CustomOptionList';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';

import { EPriceOperationTypes, IPriceOptionProps } from '~/src/entities/price';

import { ISelectedPayOption, TConfirmParams } from './types';
import { usePriceOptions } from './usePriceOptions';

interface IProps extends Pick<IOptionListProps, 'reverseVariants' | 'onClickOptionChip'> {
    equipment: IEquipment,
    onConfirmSelect: (params: TConfirmParams) => void,
    creditConditions?: ICreditCondition[],
}

const AllPurchase = ({
    equipment,
    onConfirmSelect,
    creditConditions,

    reverseVariants,
    onClickOptionChip,
}: IProps): JSX.Element => {
    const { title, testDrive } = equipment;

    const { priceOptions, payOptions, testDriveOptions } = usePriceOptions(equipment, creditConditions);

    const [selectedOption, setSelectedOption] = useState<IPriceOptionProps>();
    const [selectedPayOption, setSelectedPayOption] = useState<ISelectedPayOption>({ optionId: '', variantId: '' });

    const selectOptionHandler = (optionId: string | number, variantId: string | number) => {
        setSelectedPayOption({ optionId, variantId });

        const priceOption = priceOptions.find(el => Number(el.value) === Number(variantId));
        setSelectedOption(priceOption);
    };

    const confirmSelectHandler = () => {
        onConfirmSelect({
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            option: selectedOption!,
            payOption: selectedPayOption,
            testDriveOption: (testDrive && selectedPayOption.optionId === EPriceOperationTypes.TestDrive)
                ? {
                    duration: testDrive.duration,
                    priceDuring: testDrive.priceDuring,
                }
                : undefined,
        });
    };

    return (
        <>
            <TextWrapper $lastIndent={false}>
                <H3 $withIndent={false}>Варианты покупки</H3>
                <Paragraph4>{title}</Paragraph4>
            </TextWrapper>

            <ListContainer $direction={'column'} $wrap={'nowrap'} $size={16}>
                <OptionList
                    options={payOptions}
                    selectedOptionId={selectedPayOption.optionId}
                    selectedVariantId={selectedPayOption.variantId}
                    onClickOption={selectOptionHandler}
                    onClickOptionChip={onClickOptionChip}
                    reverseVariants={reverseVariants}
                />
                {testDriveOptions && (
                    <TestDriveOptions
                        option={testDriveOptions}
                        selectedOptionId={selectedPayOption.optionId}
                        selectedVariantId={selectedPayOption.variantId}
                        onClickOption={selectOptionHandler}
                        description={testDriveOptions.description}
                        reverseVariants={reverseVariants}
                    />
                )}
            </ListContainer>

            <ButtonGroup>
                <Button size={'large'} bType={'action'} onClick={confirmSelectHandler} disabled={!selectedOption}>Выбрать</Button>
            </ButtonGroup>
        </>
    );
};

export default AllPurchase;
